const fragmentConfig = {
  header: {
    identifier: 'wtr-website-common-header',
  },
  footer: {
    identifier: 'wtr-website-common-footer',
  },
  siteWideBanner: {
    identifier: 'wtr-website-common-site-wide-banner',
  },
  topBanner: {
    identifier: 'wtr-website-common-top-banner',
  },
} as const;

export default fragmentConfig;
